// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"numbers-9"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M8.5 19H15C15.5523 19 16 18.5523 16 18V12M16 12H9C8.44772 12 8 11.5523 8 11V6C8 5.44772 8.44772 5 9 5H15C15.5523 5 16 5.44772 16 6V12Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Numbers9Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'numbers-9',
    ref,
    icon: element,
  },
));

Numbers9Icon.displayName = 'Numbers9Icon';

export default Numbers9Icon;
